<input
  (blur)="propagateTouch(searchInput); onBlur()"
  (keydown.tab)="onTab($event)"
  (selectItem)="onSelected($event)"
  [(ngModel)]="model"
  [autofocus]="hasfocus"
  [inputFormatter]="inputFormatter"
  [ngbTypeahead]="search"
  [resultFormatter]="resultFormatter"
  #searchInput
  class="form-control typeahead-input"
  type="search" />
